export const kundendienstPaths = {
	kundendienst: "/kundendienst",
	noCustomer: "nocustomer",
	customer: "customer",
	bikeIssue: "bike-issue"
}
